<template>
  <div style="display: flex;align-items: center;flex-direction: column;">
    <el-tabs type="border-card" style="width: 100%; margin-bottom: 30px">
      <el-tab-pane label="组立" v-if="parentData.process_stage === 'check_process_zl'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ zuliCheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ zuliCheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ zuliCheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ zuliCheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ zuliCheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ zuliCheckInfo.create_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ zuliCheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ zuliCheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[0]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="zuliCheckInfo.pictures !== null">
              <el-image v-for="imageUrl in zuliCheckInfo.pictures_list" :preview-src-list="zuliCheckInfo.pictures_list"
                        v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ zuliCheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="前部品" v-if="parentData.process_stage === 'check_process_qb'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ qianbuCheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ qianbuCheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ qianbuCheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ qianbuCheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ qianbuCheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ qianbuCheckInfo.create_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ qianbuCheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ qianbuCheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[1]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="qianbuCheckInfo.pictures !== null">
              <el-image v-for="imageUrl in qianbuCheckInfo.pictures_list"
                        :preview-src-list="qianbuCheckInfo.pictures_list" v-bind:key="imageUrl" class="imageStyle"
                        :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ qianbuCheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="玻璃" v-if="parentData.process_stage === 'check_process_bl'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ boliCheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ boliCheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ boliCheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ boliCheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ boliCheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ boliCheckInfo.create_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ boliCheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ boliCheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail" v-loading="!change">
            <div v-show="boliImage !== 'null'" style="display: flex;justify-content: center;">
              <el-image class="imageStyle1" :src="boliImage" :preview-src-list="[boliImage]" fit="fill"></el-image>
            </div>
            <div v-if="boliBangDingRecord.length !== 0 && change">
              <div class="fontBold">玻璃绑定</div>
              <div class="nowrapDiv" style="margin-bottom: 10px" v-for="boliBangDing in boliBangDingRecord" v-bind:key="boliBangDing.id">
                <div class="fontBold">位置:<el-input v-model="boliBangDing.position" style="width: 50px" @change="updateBindPosition(boliBangDing)"/>、玻璃编号：</div>
                <div style="color: red">{{ boliBangDing.boli_piece_no }}</div>
                <el-select v-model="boliBangDing.boli_piece_no" :disabled="boliBangDing.boli_piece_no !== ''" filterable @change="bindBoliPieceNo(boliBangDing)" style="width: 180px;margin-left: 10px">
                  <el-option
                      v-for="item in boliBangDing.boliPieceNoList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
                <el-button v-if="boliBangDing.boli_piece_no" type="primary" style="margin-left: 10px" @click="unBindBoliPieceNo(boliBangDing)">解除绑定</el-button>
                <div style="display: flex; margin-top: 5px ;flex-direction: column; width: 100%">
                  <el-input v-model="boliBangDing.unbindremark" placeholder="解绑备注" style="margin-bottom: 5px"/>
                  <el-input v-model="boliBangDing.rebindremark" placeholder="绑定备注"/>
                </div>
                <div v-if="boliBangDing.skip" class="fontBold" style="margin-left: 5px">跳过安装备注：{{boliBangDing.remark}}</div>
              </div>
            </div>
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[2]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="boliCheckInfo.pictures !== null">
              <el-image v-for="imageUrl in boliCheckInfo.pictures_list" :preview-src-list="boliCheckInfo.pictures_list"
                        v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ boliCheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="后部品" v-if="parentData.process_stage === 'check_process_hb'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ houbuCheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ houbuCheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ houbuCheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ houbuCheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ houbuCheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ houbuCheckInfo.create_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ houbuCheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ houbuCheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[3]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="houbuCheckInfo.pictures !== null">
              <el-image v-for="imageUrl in houbuCheckInfo.pictures_list"
                        :preview-src-list="houbuCheckInfo.pictures_list" v-bind:key="imageUrl" class="imageStyle"
                        :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ houbuCheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="重点一" v-if="parentData.process_stage === 'zhongdian1'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ zhong1CheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ zhong1CheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ zhong1CheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ zhong1CheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ zhong1CheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ zhong1CheckInfo.create_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ zhong1CheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ zhong1CheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[5]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="zhong1CheckInfo.pictures !== null">
              <el-image v-for="imageUrl in zhong1CheckInfo.pictures_list"
                        :preview-src-list="zhong1CheckInfo.pictures_list" v-bind:key="imageUrl" class="imageStyle"
                        :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ zhong1CheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="重点二" v-if="parentData.process_stage === 'zhongdian2'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ zhong2CheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ zhong2CheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ zhong2CheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ zhong2CheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ zhong2CheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ zhong2CheckInfo.create_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ zhong2CheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ zhong2CheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[6]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="zhong2CheckInfo.pictures !== null">
              <el-image v-for="imageUrl in zhong2CheckInfo.pictures_list"
                        :preview-src-list="zhong2CheckInfo.pictures_list" v-bind:key="imageUrl" class="imageStyle"
                        :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ zhong2CheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="重点三" v-if="parentData.process_stage === 'zhongdian3'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ zhong3CheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ zhong3CheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ zhong3CheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ zhong3CheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ zhong3CheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ zhong3CheckInfo.create_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ zhong3CheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ zhong3CheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[7]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="zhong3CheckInfo.pictures !== null">
              <el-image v-for="imageUrl in zhong3CheckInfo.pictures_list"
                        :preview-src-list="zhong3CheckInfo.pictures_list" v-bind:key="imageUrl" class="imageStyle"
                        :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ zhong3CheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="完成品" v-if="parentData.process_stage === 'check_process_wcp'">
        <div class="checkInfo" style="display: flex; flex-direction: column; align-items: center">
          <div class="detail" style="width: 100%">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ wcpCheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ wcpCheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ wcpCheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ wcpCheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ wcpCheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ wcpCheckInfo.create_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ wcpCheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ wcpCheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail" style="width: 100%">
            <div v-show="wcpImage !== 'null'" style="display: flex;justify-content: center;">
              <el-image class="imageStyle1" :src="wcpImage" :preview-src-list="[wcpImage]" fit="fill"></el-image>
            </div>
            <!--            <div v-show="boliBangDingRecord.length !== 0">-->
            <!--              <div class="fontBold">玻璃绑定</div>-->
            <!--              <div class="nowrapDiv" style="margin-bottom: 10px" v-for="boliBangDing in boliBangDingRecord" v-bind:key="boliBangDing.id">-->
            <!--                <div class="fontBold">位置{{boliBangDing.position}}、玻璃编号：</div>-->
            <!--                <div style="color: red">{{ boliBangDing.boli_piece_no }}</div>-->
            <!--              </div>-->
            <!--            </div>-->
            <div v-show="zuliPointList.length !== 0" style="margin-bottom: 10px">
              <div class="nowrapDiv">
                <div class="fontBold">寸法检查:</div>
              </div>
              <div class="nowrapDiv" v-for="(sizeItem,index) in zuliPointList" v-bind:key="sizeItem.id">
                <div class="detailDiv" style="align-items: center">
                  <div class="fontBold" style="width: 180px">{{ index + 1 }}、测定处{{ sizeItem.point_name }}实测值：</div>
                  <el-input-number v-model="sizeItem.measured_value" size="small" step="0.5" style="margin: 2px 0px"
                                   @change="valueChange(sizeItem)"
                                   :style="(sizeItem.measured_value<sizeItem.minValue || sizeItem.measured_value>sizeItem.maxValue)? 'webkit-text-fill-color:red' : 'webkit-text-fill-color:black'"/>
                </div>
                <div class="detailDiv" style="align-items: center">
                  <div class="fontBold" style="width: 180px; text-align: center">容许范围：</div>
                  <div>{{ sizeItem.minValue }}~{{ sizeItem.maxValue }}</div>
                </div>
              </div>
            </div>

            <div v-show="diagonalInfo.length !== 0" style="margin-bottom: 10px">
              <div class="nowrapDiv">
                <div class="fontBold">对角线检查:</div>
              </div>
              <div class="nowrapDiv" v-for="(diagonalItem,index) in diagonalInfo" v-bind:key="diagonalItem.id">
                <div class="fontBold">{{ index + 1 }}、对角线{{ diagonalItem.position }}：</div>
                <div>
                  <el-input-number v-model="diagonalItem.value1" size="small" step="0.5" style="margin: 2px 0px"
                                      @change="diagonalChange(diagonalItem)"/>
                </div>
                <div>
                  <el-input-number v-model="diagonalItem.value2" size="small" step="0.5" style="margin: 2px 5px 0px"
                                                                @change="diagonalChange(diagonalItem)"/>
                </div>
                <div class="fontBold" style="margin-left: 10px">对角线差：{{ Math.abs(diagonalItem.value1 - diagonalItem.value2)}}</div>
                <div style="margin-left: 10px">
                  <text class="fontBold">结果：</text>
                  <el-select v-model="diagonalItem.result" @change="diagonalChange(diagonalItem)" style="width: 90px">
                    <el-option
                        v-for="item in resultOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                  </el-select>
                </div>
              </div>
            </div>

            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[4]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="wcpCheckInfo.pictures !== null">
              <el-image v-for="imageUrl in wcpCheckInfo.pictures_list" :preview-src-list="wcpCheckInfo.pictures_list"
                        v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-button v-if="parentData.process_stage === 'check_process_wcp'" type="primary" style="position:absolute; bottom: 0; z-index: 1" @click="updateData">保存更改</el-button>
  </div>
</template>

<script>
export default {
  name: "BusZuliZhiJianEditForm",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      zuliCheckInfo: {},
      qianbuCheckInfo: {},
      boliCheckInfo: {},
      houbuCheckInfo: {},
      wcpCheckInfo: {},
      zhong1CheckInfo: {},
      zhong2CheckInfo: {},
      zhong3CheckInfo: {},
      checkItemList: [],
      boliBangDingRecord: [],
      boliImage: '',
      wcpImage: '',
      zuliPointList: [],
      diagonalInfo: [],
      sizeItems:[],
      diagonalItems:[],
      change:true,
      resultOption:[
        {value:'true',label:'合格'},
        {value:'false',label:'不合格'}
      ]
    }
  },
  methods: {
    async getZuliCheckInfo(stage) {
      let {data: res} = await this.$axios.get('/api/zuli/check/info?inId=' + this.parentData.in_id + '&stage=' + stage);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        if (stage === 0) {
          this.zuliCheckInfo = res.data
        } else if (stage === 1) {
          this.qianbuCheckInfo = res.data
        } else if (stage === 2) {
          this.boliCheckInfo = res.data
        } else if (stage === 3) {
          this.houbuCheckInfo = res.data
        } else if (stage === 4) {
          this.wcpCheckInfo = res.data
        } else if (stage === 5) {
          this.zhong1CheckInfo = res.data
        } else if (stage === 6) {
          this.zhong2CheckInfo = res.data
        } else if (stage === 7) {
          this.zhong3CheckInfo = res.data
        }
      }
      let {data: res1} = await this.$axios.get('/api/zuli/check/item/list?stageId=' + stage + '&inId=' + this.parentData.in_id);
      if (res1.message !== "") {
        this.$message.error(res1.message);
      } else {
        this.checkItemList[stage] = res1.data
      }
    },
    async getZuliBoliBangDingRecord(stage) {
      let {data: res} = await this.$axios.get('/api/zuli/boli/bangding/record?stage=' + stage + '&inId=' + this.parentData.in_id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        res.data.forEach((item)=>{
          this.getBoliPieceNoList(item).then((result)=>{
            item.boliPieceNoList = result
          })
        })
        this.boliBangDingRecord = res.data
      }
    },
    async getZuliImage(stage) {
      let {data: res} = await this.$axios.get('/api/zuli/point/image?wujianId=' + this.parentData.wujian_id + '&unitType=' + this.parentData.unit_type);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        if (stage === 2) {
          this.boliImage = res.data
        } else {
          this.wcpImage = res.data
        }
      }
    },
    async getZuliPointList() {
      let {data: res} = await this.$axios.get('/api/zuli/point/check/record?inId=' + this.parentData.in_id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.zuliPointList = res.data
      }
    },
    async getZuliDiagonalInfo() {
      let {data: res} = await this.$axios.get('/api/zuli/diagonal/info?inId=' + this.parentData.in_id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.diagonalInfo = res.data
      }
    },
    async getBoliPieceNoList(item){
      let {data: res} = await this.$axios.post('bus/datasource/getBoliPieceNoList',item);
      if (res.success) {
        return res.data.children
      }else {
        return []
      }
    },
    async bindBoliPieceNo(boliBangDing){
      this.parentData.boli_piece_no = boliBangDing.boli_piece_no
      this.parentData.boliBangDingId = boliBangDing.id
      this.parentData.rebindremark = boliBangDing.rebindremark
      if(boliBangDing.rebindremark) {
        this.change = false
        let {data: res} = await this.$axios.post('bus/zuliZhiJianRecord/bindBoliPieceNo', this.parentData);
        if (res.success) {
          this.$message.success("绑定成功!")
        }
        this.getZuliBoliBangDingRecord(2)
        this.change = true
      }else {
        boliBangDing.boli_piece_no = ""
        this.$message.warning("请先输入绑定备注！")
      }

    },
    async unBindBoliPieceNo(boliBangDing){
      this.parentData.boli_piece_no = boliBangDing.boli_piece_no
      this.parentData.boliBangDingId = boliBangDing.id
      this.parentData.unbindremark = boliBangDing.unbindremark
      if(boliBangDing.unbindremark) {
        this.change = false
        let {data: res} = await this.$axios.post('bus/zuliZhiJianRecord/unBindBoliPieceNo', this.parentData);
        if (res.success) {
          this.$message.success("解绑成功!请重新绑定")
        }
        this.getZuliBoliBangDingRecord(2)
        this.change = true
      }else {
        this.$message.warning("请先输入解绑备注！")
      }

    },

    async updateBindPosition(boliBangDing){
      this.parentData.boliBangDingId = boliBangDing.id
      this.parentData.position = boliBangDing.position
      this.change = false
      if(boliBangDing.position) {
        let {data: res} = await this.$axios.post('bus/zuliZhiJianRecord/updateBindPosition', this.parentData);
        if (res.success) {
          this.$message.success("绑定位置修改成功！")
        }
      }else {
        this.$message.warning("绑定位置不能为空！")
      }
      this.getZuliBoliBangDingRecord(2)
      this.change = true

    },

    valueChange(sizeItem){
      sizeItem.result = sizeItem.minValue <= sizeItem.measured_value && sizeItem.measured_value <= sizeItem.maxValue
      let exist = false
      this.sizeItems.forEach((item)=>{
        if (item.id === sizeItem.id){
          exist = true
        }
      })

      if (!exist) {
        this.sizeItems.push(sizeItem)
      }
    },
    async updateMeasuredValue(){
      let data1 = {
        sizeItems:[],
        id:null
      }
      data1.sizeItems = this.sizeItems
      data1.id = this.wcpCheckInfo.id
      let {data:res} = await this.$axios.post('bus/zuliZhiJianRecord/updateMeasuredValue',data1)
      if (res.success){
        this.$message.success("实测值修改成功！")
      }
    },
    diagonalChange(diagonalItem){
      let exist = false
      this.diagonalItems.forEach((item)=>{
        if (item.id === diagonalItem.id){
          exist = true
        }
      })

      if (!exist) {
        this.diagonalItems.push(diagonalItem)
      }
    },
    async updateDiagoal(){
      let data2 = {
        diagonalItems:[],
        id:null
      }
      data2.diagonalItems = this.diagonalItems
      data2.id = this.wcpCheckInfo.id
      let {data:res} = await this.$axios.post('bus/zuliZhiJianRecord/updateDiagoal',data2)
      if (res.success){
        this.$message.success("对角线修改成功！")
      }
    },
    updateData(){
      this.updateMeasuredValue()
      this.updateDiagoal()
    }
  },
  created() {
    if (this.parentData.process_stage === 'check_process_zl') {
      this.getZuliCheckInfo(0)
    }
    if (this.parentData.process_stage === 'check_process_qb') {
      this.getZuliCheckInfo(1)
    }
    if (this.parentData.process_stage === 'check_process_bl') {
      this.getZuliCheckInfo(2)
      this.getZuliBoliBangDingRecord(2)
      this.getZuliImage(2)
    }
    if (this.parentData.process_stage === 'check_process_hb') {
      this.getZuliCheckInfo(3)
    }
    if (this.parentData.process_stage === 'check_process_wcp') {
      this.getZuliCheckInfo(4)
      this.getZuliImage(4)
      this.getZuliPointList()
      this.getZuliDiagonalInfo()
    }
    if (this.parentData.process_stage === 'zhongdian1') {
      this.getZuliCheckInfo(5)
    }
    if (this.parentData.process_stage === 'zhongdian2') {
      this.getZuliCheckInfo(6)
    }
    if (this.parentData.process_stage === 'zhongdian3') {
      this.getZuliCheckInfo(7)
    }
  }
}
</script>

<style scoped>
.checkInfo {
  background-color: #F4F8FD;
  padding-top: 2px;
}

.detail {
  background-color: #FFFFFF;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
}

.detailDiv {
  width: 50%;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fontBold {
  font-weight: bold;
}

.width1 {
  width: 25%;
}

.width2 {
  width: 39%;
}

.width3 {
  width: 12.5%;
}

.width4 {
  width: 30%;
}

.width5 {
  width: 50%;
}

.nowrapDiv {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.ngdiv {
  width: 50px;
  height: 25px;
  background-color: #F1F1F1;
  margin-right: 5px;
  margin-bottom: 5px;
}

.ngdiv1 {
  font-size: 12px;
  width: 50px;
  height: 25px;
  background-color: #1A73E8;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-bottom: 5px;
}

.imageStyle {
  width: 87px;
  height: 87px;
  margin-right: 5px
}

.imageStyle1 {
  width: 500px;
  height: 500px;
  margin-right: 5px
}

>>> .el-tabs--border-card > .el-tabs__content {
  padding: 1px !important;
}

.el-input__inner {
  color: red;
}
</style>
